/**
 * Format a numeric file size in bytes into a displayable string.
 * 
 * size -- {Number} The size in bytes
 * 
 * places -- {Number} The number of places to show to the right of the decimal.
 *           Must be >= 0.
 * 
 *           default: 2
 */
export function formatFileSize(size : number, places : number) {
    if (places === undefined) places = 2;
    if (size < 1024) return size.toFixed(places) + 'B';
    size = size / 1024;
    if (size < 1024) return size.toFixed(places) + 'KB';
    size = size / 1024;
    if (size < 1024) return size.toFixed(places) + 'MB';
    size = size / 1024;
    if (size < 1024) return size.toFixed(places) + 'GB';
    size = size / 1024;
    if (size < 1024) return size.toFixed(places) + 'TB';
    throw new Error('Only sizes up to 1024TB supported');
}


// WEBPACK FOOTER //
// ./lib/formatFileSize.ts